export enum AmbassadorSource {
  Other = '1',
  Site = '2',
  SocialNetwork = '3',
  Colleague = '4',
  Advertisement = '5',
  EducationalCenter = '6',
  Manager = '7'
}

const { Advertisement, Colleague, EducationalCenter, Manager, Other, Site, SocialNetwork } = AmbassadorSource

const nameMapping = new Map([
  [Advertisement, 'Из рекламы'],
  [Colleague, 'От коллег'],
  [EducationalCenter, 'От обучающих центров'],
  [Manager, 'Пригласил менеджер'],
  [Other, 'Другое'],
  [Site, 'На нашем сайте'],
  [SocialNetwork, 'В наших социальных сетях']
])

export const AmbassadorSourceUtils = {
  sortedMembers: [Site, SocialNetwork, Colleague, Advertisement, EducationalCenter, Manager, Other],
  getName: (x: AmbassadorSource): string => nameMapping.get(x)!
}
